import ObjectBuilderInterface from "@/modules/api/object-builder.interface";

import FactoryProductDepositSetting from "./factory-product-deposit-setting.model";

export default class FactoryProductDepositSettingFactory
  implements ObjectBuilderInterface<FactoryProductDepositSetting> {
  public buildFromJSON(
    data: Record<string, unknown>
  ): FactoryProductDepositSetting {
    if (
      typeof data.id !== "string" ||
      typeof data.factoryId !== "string" ||
      data.productId === undefined ||
      data.depositPercent === undefined
    ) {
      throw new Error("Product deposit settings require all values");
    }
    const value = new FactoryProductDepositSetting(
      data.id,
      data.factoryId,
      String(data.productId),
      Number(data.depositPercent)
    );
    value.isNew = false;
    return value;
  }
}
